import { LocalHospital } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import SwapVerticalCircleIcon from '@mui/icons-material/SwapVerticalCircle';
import { AppBar, Button, CardContent, Divider, IconButton, List, ListItem, ListItemText, Paper, SvgIcon, Tab, Tabs, Typography, createFilterOptions } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import { styled as muiStyled } from '@mui/material/styles';
import { CustomAutocomplete } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomAutocomplete';
import RegraCpf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCpf';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { TituloPagina, TituloSecao } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { limparMensagens } from 'esocial.web.react.lib/cjs/store/reducers/mensagens';
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { getStringValue, isObjectWithProperties, isUndefinedOrNull, obterOpcaoAutocompletePorValorVep, rolarVisualizacaoAteElemento, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { idInformacoesUsuarioArmazenamentoBrowser, obterAcessoArmazenamentoBrowser } from 'esocial.web.react.lib/cjs/utils/servicos';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import VMasker from 'vanilla-masker';
import { MovimentacoesTrabalhistas } from './MovimentacoesTrabalhistas';

const NomeTrabalhadorCard = muiStyled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 500,
    marginBottom: '0.5rem',
    color: theme.palette.primary.main
}));

function HeartPulse(props) {
    return (
        <SvgIcon fontSize="inherit" {...props}>
            <path fill="currentColor" d="M7.5,4A5.5,5.5 0 0,0 2,9.5C2,10 2.09,10.5 2.22,11H6.3L7.57,7.63C7.87,6.83 9.05,6.75 9.43,7.63L11.5,13L12.09,11.58C12.22,11.25 12.57,11 13,11H21.78C21.91,10.5 22,10 22,9.5A5.5,5.5 0 0,0 16.5,4C14.64,4 13,4.93 12,6.34C11,4.93 9.36,4 7.5,4V4M3,12.5A1,1 0 0,0 2,13.5A1,1 0 0,0 3,14.5H5.44L11,20C12,20.9 12,20.9 13,20L18.56,14.5H21A1,1 0 0,0 22,13.5A1,1 0 0,0 21,12.5H13.4L12.47,14.8C12.07,15.81 10.92,15.67 10.55,14.83L8.5,9.5L7.54,11.83C7.39,12.21 7.05,12.5 6.6,12.5H3Z" />
        </SvgIcon>
    );
}

function HardHat(props) {
    return (
        <SvgIcon fontSize="inherit" {...props}>
            <path fill="currentColor" d="M9.87,12.15L9,6.46C10.95,5.84 13.05,5.84 15,6.46L14.13,12.15C14.06,12.64 13.63,13 13.13,13H10.86C10.37,13 9.94,12.64 9.87,12.15M22,16V16C22,15.21 21.53,14.5 20.8,14.17C20.32,11.86 18.96,9.83 17,8.5L15.24,13.34C15.1,13.74 14.72,14 14.3,14H9.7C9.28,14 8.9,13.74 8.76,13.34L7,8.5C5.04,9.83 3.68,11.86 3.2,14.16C2.47,14.5 2,15.2 2,16L8.45,17.84C8.81,17.94 9.18,18 9.55,18H14.43C14.8,18 15.17,17.94 15.53,17.84L22,16Z" />
        </SvgIcon>
    );
}

const ButtonTexto = muiStyled(Button)(() => ({
    marginRight: '10px',
    boxShadow: 'none',
    lineHeight: '1.5',
    borderRadius: '4px !important',
    fontSize: '12px',
    textTransform: 'none',
    textAlign: 'left',
    maxWidth: '15rem',
    minHeight: '3rem',

    "& > svg": {
        marginRight: '8px',
        fontSize: '2rem',
    }
}));

const HeaderMatricula = muiStyled(AppBar)(() => ({
    backgroundColor: '#EDEDED',
    borderRadius: '4px 4px 0px 0px'
}));

const InfosContrato = muiStyled('div')(() => ({
    flexGrow: 1,

    "& li": {
        display: 'inline-block',
        width: '33%',
        verticalAlign: 'top',
    }
}));

const ContainerInformacoesContrato = muiStyled(Paper)`
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    padding: 0 30px 15px;
    margin-bottom: 1rem;
`;

const TituloContratosTrabalhadorBox = muiStyled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2rem 0 1rem;
`;

function TabPanel(props) {
    const { children, value, indice, cpf, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== indice}
            id={`painelAba-${cpf}-${indice}`}
            key={`contrato-${cpf}-${indice}`}
            aria-labelledby={`botaoAba-${cpf}-${indice}`}
            {...other}
        >
            {value === indice && children}
        </div>
    );
}

const actions = (
    [{
        evento: "cat",
        icon: <LocalHospital />,
        primaryText: "Comunicação de Acidente de Trabalho (CAT)",
        name: "Comunicação de Acidente de Trabalho (CAT)",
    },
    {
        evento: "monit-saude",
        icon: <HeartPulse />,
        primaryText: "Monitoramento de Saúde",
        name: "Monitoramento de Saúde",
    },
    {
        evento: "cond-ambientais",
        icon: <HardHat />,
        primaryText: "Condições Ambientais do Trabalho e Fatores de Risco",
        name: "Condições Ambientais do Trabalho - Agentes Nocivos",
    }]
);

const filterOptions = createFilterOptions({
    stringify: option => option.chaveAuxiliarFiltro
});

const numeroMaximoTrabalhadores = 12;
const codigosCategoriaARemover = '104';

function GestaoTrabalhadores({ tsv = false }) {
    const { get } = useRequisicaoControlada();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [listaTrabalhadores, setListaTrabalhadores] = useState(null);
    const [abaAtual, setAbaAtual] = useState(0);
    const [exibirFiltro, setExibirFiltro] = useState(false);
    const [divContratosOpen, setDivContratosOpen] = useState(false);
    const [dadosTrabalhador, setDadosTrabalhador] = useState({});
    const [movimentacoesTrabalhistasOpen, setMovimentacoesTrabalhistasOpen] = useState(false);
    const [dadosContratoAtual, setDadosContratoAtual] = useState({ idContrato: 0, tsv: 0, admPreliminar: 0, processoTrabalhista: 0, idTrabalhador: 0 });
    const [itemMenuSelecionado, setItemMenuSelecionado] = useState(null);
    const [pesquisaEmAndamento, setPesquisaEmAndamento] = useState(false);

    // Estado auxiliar usado no autocomplete de pesquisa de trabalhadores
    // O atributo "key" será responsável por guardar a chave de identificação do componente e permitir
    // sua rerenderização para limpeza a qualquer tempo
    // O atributo inputValue guardará o valor mantido no componente interno do autocomplete para que
    // a validação de CPF seja aplicada somente quando algo for de fato informado
    const [auxiliarAutocomplete, setAuxiliarAutocomplete] = useState({ key: uuidv4(), inputValue: "" });

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};
    objetoComponentesTocados['auxiliarAutocomplete'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};
        objetoRegrasValidacao['auxiliarAutocomplete'] = new RegraCpf(auxiliarAutocomplete.inputValue, auxiliarAutocomplete.inputValue.length > 0 && componenteTocadoFormulario['auxiliarAutocomplete']);
        objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [auxiliarAutocomplete.inputValue, componenteTocadoFormulario]);

    const handleOpenContratos = (key) => {
        setDadosTrabalhador(listaTrabalhadores[key]);
        setDadosContratoAtual({
            idContrato: listaTrabalhadores[key][0].idContrato,
            tsv: listaTrabalhadores[key][0].trabalhadorSemVinculo,
            admPreliminar: listaTrabalhadores[key][0].admissaoPreliminar,
            processoTrabalhista: listaTrabalhadores[key][0].processoTrabalhista,
            idTrabalhador: listaTrabalhadores[key][0].idTrabalhador
        });
        setAbaAtual(0);
        setDivContratosOpen(true);
        setMovimentacoesTrabalhistasOpen(false);
        setItemMenuSelecionado(key);

        // Direcionar ao bloco de contratos do trabalhador selecionado
        rolarVisualizacaoAteElemento('contratos-trabalhador-selecionado');
    }

    const handleCloseContratos = () => {
        if (!exibirFiltro) {
            setDadosTrabalhador({});
            setDadosContratoAtual({ idContrato: 0, tsv: 0, admPreliminar: 0, processoTrabalhista: 0, idTrabalhador: 0 });
            setDivContratosOpen(false);
            setMovimentacoesTrabalhistasOpen(false);
            setItemMenuSelecionado(null);
        }
        else {
            inicializar(false);
        }
    }

    const handleChangeAbaContrato = (e, n) => {
        setAbaAtual(n);
        setDadosContratoAtual({
            idContrato: dadosTrabalhador[n].idContrato,
            tsv: dadosTrabalhador[n].trabalhadorSemVinculo,
            admPreliminar: dadosTrabalhador[n].admissaoPreliminar,
            processoTrabalhista: dadosTrabalhador[n].processoTrabalhista,
            idTrabalhador: dadosTrabalhador[n].idTrabalhador
        });
        setMovimentacoesTrabalhistasOpen(false);
    };

    const processamentoResposta = (conteudoResposta) => {
        if (!isUndefinedOrNull(conteudoResposta)) {
            setListaTrabalhadores(conteudoResposta);
        }

        setPesquisaEmAndamento(false);
    };

    let { idTrabalhador } = useParams();
    async function inicializar(verificarNecessidadePesquisaInicial = true) {
        // Forçar reinicialização dos estados pois o usuário pode fazer a troca entre Gestão de Empregados e Trabalhadores sem Vínculo (e vice-versa)
        // e a aplicação manter os dados carregados na requisição da primeira tela
        setListaTrabalhadores(null);
        setAbaAtual(0);
        setDivContratosOpen(false);
        setDadosTrabalhador({});
        setMovimentacoesTrabalhistasOpen(false);
        setDadosContratoAtual({ idContrato: 0, tsv: 0, admPreliminar: 0, processoTrabalhista: 0, idTrabalhador: 0 });
        setItemMenuSelecionado(null);

        // Forçar a rerenderização do autocomplete para que o mesmo seja reestabelecido com os seus valores default
        // e gere o efeito de "limpeza" dos campos
        setAuxiliarAutocomplete({ key: uuidv4(), inputValue: '' });

        if (verificarNecessidadePesquisaInicial) {
            let executarPesquisaInicial = false;

            try {
                const informacoesUsuario = await obterAcessoArmazenamentoBrowser().get(idInformacoesUsuarioArmazenamentoBrowser);

                // Obter a quantidade de trabalhadores do empregador para a avaliação da exibição do filtro de pesquisa
                if (!isUndefinedOrNull(informacoesUsuario)) {
                    const quantidadeTrabalhadores = parseInt(informacoesUsuario.usuario.empregador.quantidadeTrabalhadores);
                    executarPesquisaInicial = quantidadeTrabalhadores <= numeroMaximoTrabalhadores;
                }

            } catch (error) {
                console.error(error);
            }
            finally {
                setExibirFiltro(!executarPesquisaInicial);
            }

            if (executarPesquisaInicial) {
                setPesquisaEmAndamento(true);
                await get(`/gestaoTrabalhadores/pesquisar/${numeroMaximoTrabalhadores}/${tsv}/${codigosCategoriaARemover}/${true}/${true}`, processamentoResposta);
            }
            else {
                // Verificar se é preciso colocar o trabalhador definido por (idTrabalhador, tsv) em foco
                if (getStringValue(idTrabalhador).length > 0) {
                    await get(`gestaoTrabalhadores/pesquisarTrabalhador/${idTrabalhador}/${tsv}/${true}/${true}`, processamentoResposta);
                }
            }
        }
    }

    useEffect(() => {
        inicializar();
    }, [tsv]);

    // Atribuição indireta para o trabalhador em foco
    useEffect(() => {
        if (exibirFiltro && isObjectWithProperties(listaTrabalhadores)) {
            let key = Object.keys(listaTrabalhadores)[0];

            setDadosTrabalhador(listaTrabalhadores[key]);
            setDadosContratoAtual({
                idContrato: listaTrabalhadores[key][0].idContrato,
                tsv: listaTrabalhadores[key][0].trabalhadorSemVinculo,
                admPreliminar: listaTrabalhadores[key][0].admissaoPreliminar,
                idTrabalhador: listaTrabalhadores[key][0].idTrabalhador,
                processoTrabalhista: listaTrabalhadores[key][0].processoTrabalhista
            });
            setDivContratosOpen(true);
            setMovimentacoesTrabalhistasOpen(false);
        }
    }, [exibirFiltro, listaTrabalhadores]);

    function obterValorTrabalhadorSelecionado(dadosTrabalhador) {
        if (Array.isArray(dadosTrabalhador) && dadosTrabalhador.length > 0) {
            return dadosTrabalhador[0].idTrabalhador;
        }

        return '';
    }

    function obterFonteDadosAutocompleteTrabalhadorSelecionado(dadosTrabalhador) {
        if (Array.isArray(dadosTrabalhador) && dadosTrabalhador.length > 0) {
            const value = {
                tsv: dadosTrabalhador[0].trabalhadorSemVinculo,
                chaveAuxiliarFiltro: `${dadosTrabalhador[0].cpf.replace(/\D/g, '')}|${dadosTrabalhador[0].cpf}`,
                rotulo: `${dadosTrabalhador[0].cpf} - ${dadosTrabalhador[0].nome}`,
                valor: dadosTrabalhador[0].idTrabalhador
            };

            return [value];
        }

        return null;
    }

    return (
        Object.values(regraValidacaoFormulario).length > 0 &&
        <Fragment>
            <Display show={exibirFiltro || listaTrabalhadores !== null}>
                <TituloPagina>Gestão de {!tsv ? 'Empregados' : 'Trabalhadores sem Vinculo'}</TituloPagina>
            </Display>

            <Display show={exibirFiltro}>
                <CustomAutocomplete
                    key={auxiliarAutocomplete.key}
                    md={12}
                    queryUrl={`/gestaoTrabalhadores/listarTrabalhadoresAutocompleteCpfCompleto/${tsv}/${codigosCategoriaARemover}/${true}/${true}`}
                    searchWhen={auxiliarAutocomplete.inputValue.length > 0 && !regraValidacaoFormulario['auxiliarAutocomplete'].existeErro()}
                    getOptionLabel={(option) => !isUndefinedOrNull(option.rotulo) ? option.rotulo : ''}
                    filterOptions={filterOptions}
                    freeSolo
                    value={obterOpcaoAutocompletePorValorVep(obterFonteDadosAutocompleteTrabalhadorSelecionado(dadosTrabalhador), obterValorTrabalhadorSelecionado(dadosTrabalhador))}
                    onChange={async (event, value, reason) => {
                        if (reason === 'selectOption') {
                            if (!isUndefinedOrNull(value) && !isUndefinedOrNull(value.valor)) {
                                setPesquisaEmAndamento(true);
                                setAuxiliarAutocomplete({ ...auxiliarAutocomplete, inputValue: value.rotulo });

                                let strUrl = `gestaoTrabalhadores/pesquisarTrabalhador/${value.valor}/${tsv}/${true}/${true}`;
                                if (value.valor == '0') {
                                    strUrl += `/${value.chaveAuxiliarFiltro.split('|')[0]}`
                                }
                                await get(strUrl, processamentoResposta);
                            }
                        }
                        else if (reason === 'clear') {
                            inicializar(false);
                        }

                        dispatch(limparMensagens());
                    }}
                    inputValue={auxiliarAutocomplete.inputValue}
                    onInputChange={(event, value) => {
                        if (event != null) {
                            setAuxiliarAutocomplete({ ...auxiliarAutocomplete, inputValue: VMasker.toPattern(value, Mascara.CPF) });
                            setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'auxiliarAutocomplete': true });
                        }
                    }}
                    clearOnBlur={false}
                    inputProps={{
                        label: 'Informe a seguir o CPF completo',
                        maskPattern: Mascara.CPF,
                        required: true,
                        ...regraValidacaoFormulario['auxiliarAutocomplete'].obterPropriedadesValidacao()
                    }}
                />
            </Display>

            {
                listaTrabalhadores !== null ?
                    !isObjectWithProperties(listaTrabalhadores) ?
                        /*Se NÃO há trabalhadores após a pesquisa*/
                        <Typography>Não há {!tsv ? 'empregado(a)' : 'trabalhador(a) sem vínculo'} para exibição.</Typography> :

                        /*Se há trabalhadores após a pesquisa*/
                        <>
                            <Display show={!exibirFiltro}>
                                {/*Painel de Cards com os trabalhadores*/}
                                <TituloSecao variantMapping={{ h6: 'h2' }}>Lista de Trabalhadores</TituloSecao>

                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))',
                                        gap: 3,
                                    }}
                                    style={{ marginTop: '1.3rem' }}
                                >
                                    {Object.entries(listaTrabalhadores).map(([key, value]) => (
                                        <Card key={key}>
                                            <CardActionArea
                                                onClick={() => handleOpenContratos(key)}
                                                data-active={itemMenuSelecionado === key ? '' : undefined}
                                                sx={{
                                                    height: '100%',
                                                    '&[data-active]': {
                                                        backgroundColor: 'action.selected',
                                                        '&:hover': {
                                                            backgroundColor: 'action.selectedHover',
                                                        },
                                                    },
                                                }}
                                            >
                                                <CardContent sx={{ height: '100%' }}>
                                                    <NomeTrabalhadorCard variant="body1" component="div">
                                                        {value[0].nome}
                                                    </NomeTrabalhadorCard>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {VMasker.toPattern(key, Mascara.CPF)}
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    ))}
                                </Box>
                            </Display>

                            {
                                divContratosOpen &&
                                <>
                                    <TituloContratosTrabalhadorBox>
                                        <TituloSecao id="contratos-trabalhador-selecionado" variantMapping={{ h6: 'h2' }}>
                                            <span style={{ fontWeight: 400 }}>Trabalhador</span>:  {dadosTrabalhador[0].nome} - {dadosTrabalhador[0].cpf}
                                        </TituloSecao>

                                        <IconButton title="Fechar contratos do trabalhador" onClick={handleCloseContratos}>
                                            <CloseIcon />
                                        </IconButton>
                                    </TituloContratosTrabalhadorBox>

                                    <HeaderMatricula position="static" color="default">
                                        <Tabs
                                            value={abaAtual}
                                            onChange={handleChangeAbaContrato}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="contratos do trabalhador"
                                        >
                                            {dadosTrabalhador.map((trab, indice) => {
                                                let cpf = trab.cpf.replace('.', '').replace('.', '').replace('-', '');
                                                return (
                                                    <Tab key={"tab-" + cpf + "-" + indice}
                                                        label={trab.trabalhadorSemVinculo ? trab.categoria : trab.matricula}
                                                        id={`botaoAba-${cpf}-${indice}`}
                                                        aria-controls={`painelAba-${cpf}-${indice}`}
                                                    />
                                                )
                                            })}
                                        </Tabs>
                                    </HeaderMatricula>

                                    {dadosTrabalhador.map(function (trab, indice2) {
                                        let cpf = trab.cpf.replace('.', '').replace('.', '').replace('-', '');
                                        return (
                                            <TabPanel value={abaAtual} indice={indice2} cpf={cpf} key={cpf + '-' + indice2}>
                                                <ContainerInformacoesContrato elevation={3}>
                                                    <div style={{ paddingTop: '1.375rem', marginLeft: '16px' }}>
                                                        {actions.map((action, i) => {
                                                            const key = dadosTrabalhador[0].cpf.replace('.', '').replace('.', '').replace('-', '');

                                                            return (
                                                                <ButtonTexto
                                                                    key={'button_' + key + '_' + i}
                                                                    color="primary"
                                                                    variant="outlined"
                                                                    aria-label={action.name}
                                                                    onClick={e => {
                                                                        e.stopPropagation();

                                                                        switch (action.evento) {
                                                                            case "cat":
                                                                                navigate(`/cat/${dadosContratoAtual.idTrabalhador}/${dadosContratoAtual.idContrato}/${dadosContratoAtual.tsv}/${dadosContratoAtual.admPreliminar}`);
                                                                                break;
                                                                            case "monit-saude":
                                                                                navigate(`/monitoramentoSaude/${dadosContratoAtual.idTrabalhador}/${dadosContratoAtual.idContrato}/${dadosContratoAtual.tsv}/${dadosContratoAtual.admPreliminar}`);
                                                                                break;
                                                                            case "cond-ambientais":
                                                                                navigate(`/exposicaoRisco/${dadosContratoAtual.idTrabalhador}/${dadosContratoAtual.idContrato}/${dadosContratoAtual.tsv}/${dadosContratoAtual.admPreliminar}`);
                                                                                break;
                                                                        }
                                                                    }}
                                                                >
                                                                    {action.icon}
                                                                    {action.name}
                                                                </ButtonTexto>
                                                            )
                                                        })}

                                                        <ButtonTexto
                                                            aria-label="abrir movimentações trabalhistas"
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                setMovimentacoesTrabalhistasOpen(true);
                                                            }}
                                                        >
                                                            <SwapVerticalCircleIcon />
                                                            Movimentações Trabalhistas
                                                        </ButtonTexto>
                                                    </div>

                                                    <InfosContrato>
                                                        <List>
                                                            <ListItem>
                                                                <ListItemText primary="Situação" secondary={trab.situacao} />
                                                            </ListItem>
                                                            {!trab.trabalhadorSemVinculo &&
                                                                <Fragment>
                                                                    <ListItem>
                                                                        <ListItemText primary="Matrícula" secondary={trab.matricula} />
                                                                    </ListItem>
                                                                </Fragment>
                                                            }
                                                            <ListItem>
                                                                <ListItemText primary="Cargo" secondary={trab.cargo} />
                                                            </ListItem>
                                                            <ListItem>
                                                                <ListItemText primary="Categoria" secondary={trab.categoria} />
                                                            </ListItem>
                                                            <ListItem>
                                                                <ListItemText primary="Natureza da Atividade" secondary={trab.naturezaAtividade} />
                                                            </ListItem>
                                                            {!isUndefinedOrNull(trab.localTrabalho) && trab.localTrabalho.length > 0 &&
                                                                <Fragment>
                                                                    <ListItem>
                                                                        <ListItemText primary="Local de Trabalho" secondary={trab.localTrabalho} />
                                                                    </ListItem>
                                                                </Fragment>
                                                            }
                                                            <ListItem>
                                                                <ListItemText primary="Data de Admissão" secondary={trab.dataAdmissao} />
                                                            </ListItem>
                                                            {!isUndefinedOrNull(trab.dataDesligamento) && trab.dataDesligamento.length > 0 &&
                                                                <Fragment>
                                                                    <ListItem>
                                                                        <ListItemText primary="Data de Desligamento" secondary={trab.dataDesligamento} />
                                                                    </ListItem>
                                                                </Fragment>
                                                            }
                                                            <ListItem>
                                                                <ListItemText primary="Data de Nascimento" secondary={trab.dataNascimento} />
                                                            </ListItem>
                                                            {!isUndefinedOrNull(trab.descricaoCbo) && trab.descricaoCbo.length > 0 &&
                                                                <Fragment>
                                                                    <ListItem>
                                                                        <ListItemText primary="CBO" title="Classificação Brasileira de Ocupações" secondary={trab.descricaoCbo} />
                                                                    </ListItem>
                                                                </Fragment>
                                                            }
                                                            {!isUndefinedOrNull(trab.horasJornadaSemanal) && trab.horasJornadaSemanal > 0 &&
                                                                <Fragment>
                                                                    <ListItem>
                                                                        <ListItemText primary="Jornada Semanal (Horas)" secondary={trab.horasJornadaSemanal} />
                                                                    </ListItem>
                                                                </Fragment>
                                                            }
                                                            {!isUndefinedOrNull(trab.descricaoJornadaSemanal) && trab.descricaoJornadaSemanal.length > 0 &&
                                                                <Fragment>
                                                                    <ListItem>
                                                                        <ListItemText primary="Descrição da Jornada Semanal" secondary={trab.descricaoJornadaSemanal} />
                                                                    </ListItem>
                                                                </Fragment>
                                                            }
                                                        </List>
                                                    </InfosContrato>

                                                    {
                                                        movimentacoesTrabalhistasOpen &&
                                                        <>
                                                            <Divider aria-hidden="true" style={{ marginTop: '0.5rem' }} />

                                                            <div id="bloco-movimentacoes-trabalhistas" style={{ margin: '1.5rem 0' }}>
                                                                <Fieldset legend="Movimentações Trabalhistas" id="div-movimentacoes-trabalhistas">
                                                                    <MovimentacoesTrabalhistas idTrabalhador={idTrabalhador} idContrato={dadosContratoAtual.idContrato} tsv={dadosContratoAtual.tsv} admPreliminar={dadosContratoAtual.admPreliminar} processoTrabalhista={dadosContratoAtual.processoTrabalhista} />
                                                                </Fieldset>
                                                            </div>
                                                        </>
                                                    }
                                                </ContainerInformacoesContrato>
                                            </TabPanel>
                                        )
                                    })}
                                </>
                            }
                        </>

                    /*Durante a pesquisa*/
                    : (pesquisaEmAndamento && <ContentPreview />)
            }
        </Fragment >
    );
}

export default GestaoTrabalhadores;
